import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import Header from "../../components/common/Layouts/Header";
import Footer from "../../components/common/Layouts/Footer";
import HelmetWrapper from "../../components/common/Layouts/HelmetWrapper";
import heroImage from "../../assets/images/hero.png";
import featurePublishIcon from "../../assets/images/tabler_template.svg";
import featureManageIcon from "../../assets/images/carbon_event.svg";
import featureRsvpIcon from "../../assets/images/circum_box-list.svg";
import platformVideoCard from "../../assets/images/video-card.svg";
import "../../assets/styles/components_styles/aboutUsPage.css";

export default function AboutUsPage() {
  const navigate = useNavigate();
  return (
    <>
      <HelmetWrapper
        title="About Us - Bringing the World Together Through Live Experiences in Kolkata & Dubai"
        description="Pingvite brings people together through live experiences in Kolkata and Dubai, connecting communities, 
        cultures, and events on one trusted platform."
        keywords="All Event Activities in Kolkata, Upcoming Events in Saltlake, Upcoming Events in Parkstreet, 
        Upcoming Events in New Town, live events in Kolkata, upcoming events in Dubai, Events in Dubai, Best events in Dubai, 
        Live event in Dubai, Top events in Dubai"
      />

      {/* HEADER */}
      <Header isHome={false} />

      {/* CONTENT */}
      <main className="aboutUsPageRoot">
        <section className="aboutHeroSection">
          <div className="container">
            <div className="aboutHeroGrid">
              <div className="aboutHeroText">
                <h1 className="aboutHeroTitle">
                  Connecting Worldwide Through Meaningful Live Experiences
                </h1>
                <p className="aboutHeroDescription">
                  Pingvite is a next-generation smart tech platform that empowers
                  anyone to effortlessly create, manage, and promote events. With
                  seamless ticketing, secure payments, and AI-powered tools,
                  Pingvite simplifies every step of event planning - making each
                  celebration smarter, smoother, and more successful.
                </p>
                <p className="aboutHeroDescription">
                  We&apos;re redefining the way events are organized and invitations
                  are created, sent, and managed. Our platform is set to launch
                  globally, offering personalized local support to event organizers
                  and attendees around the world.
                </p>
              </div>

              <div className="aboutHeroImageWrap">
                <img
                  src={heroImage}
                  alt="People celebrating"
                  className="aboutHeroImage"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="aboutFeaturesSection">
          <div className="container">
            <div className="aboutSectionTitle">
              <h2>
                Our Application
                <br />
                <span>Features</span>
              </h2>
            </div>

            <div className="aboutFeatureGrid">
              <div className="aboutFeatureCard">
                <div className="aboutFeatureIcon">
                  <img src={featurePublishIcon} alt="Publish feature" />
                </div>
                <div className="aboutFeatureContent">
                  <h3>Publish Your Events</h3>
                  <p>
                    From in-person to online events, promote your events in
                    popular locations and scale up to global audiences.
                  </p>
                </div>
              </div>

              <div className="aboutFeatureCard">
                <div className="aboutFeatureIcon">
                  <img src={featureManageIcon} alt="Manage feature" />
                </div>
                <div className="aboutFeatureContent">
                  <h3>Manage Your Events</h3>
                  <p>
                    Publish events, manage ticketing from multiple venues and
                    event promotions - all from a single dashboard.
                  </p>
                </div>
              </div>

              <div className="aboutFeatureCard">
                <div className="aboutFeatureIcon">
                  <img src={featureRsvpIcon} alt="RSVP feature" />
                </div>
                <div className="aboutFeatureContent">
                  <h3>Custom Invites & RSVP</h3>
                  <p>
                    Design your custom invites, broadcast to your contacts
                    lists, and get real-time attendees count with the RSVP
                    feature.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="aboutPlatformSection">
          <div className="container">
            <div className="aboutPlatformGrid">
              <div className="aboutPlatformCards">
                <div className="aboutPlatformCardsInner">
                  <div className="aboutPlatformCol">
                    <div className="aboutInfoBox aboutInfoBoxSmall">
                      <button type="button" className="moreArrow">
                        <span className="arrowUpIcon"></span>
                      </button>
                      <h3>Create Eye-Catching Invitations</h3>
                    </div>
                    <div className="aboutInfoBox aboutInfoBoxHighlight">
                      <button type="button" className="moreArrow">
                        <span className="arrowUpIcon"></span>
                      </button>
                      <h3>Your DIY event management platform</h3>
                      <p>
                        Manage events of any size with ease from a single
                        dashboard. Start with our integrated tools and take
                        your events to a global stage.
                      </p>
                    </div>
                  </div>

                  <div className="aboutPlatformCol">
                    <div className="aboutInfoBox aboutInfoVideoBox">
                      <img src={platformVideoCard} alt="Platform video preview" />
                    </div>
                    <div className="aboutInfoBox aboutInfoBoxSmall">
                      <button type="button" className="moreArrow">
                        <span className="arrowUpIcon"></span>
                      </button>
                      <h3>
                        1200+ Users
                        <br />
                        (In Pipeline)
                      </h3>
                    </div>
                  </div>
                </div>
              </div>

              <div className="aboutPlatformContent">
                <div className="aboutSectionTitle">
                  <h2>
                    The <span>All-In-One</span> platform to take your events
                    global
                  </h2>
                </div>
                <p>
                  Pingvite simplifies event registration and ticketing for
                  online and live experience events. Manage small gatherings to
                  conferences using in-built tools.
                </p>
                <p>
                  Elevate your visitor experience with custom invites, plan
                  ahead with RSVP on guest lists, multi-level ticketing and
                  reservations. Intuitive dashboard makes event management
                  hassle-free for organizers - increase their outreach with
                  targeted promotions, manage revenues better with fast payouts,
                  track ticketing revenues and refunds, and use analytics to
                  discover which events and locations are revenue drivers.
                </p>
                <div className="aboutPlatformBtnWrap">
                  <Button type="primary" size="large" className="btnGradient" onClick={() => navigate("/create-new-event")}>Create Your Event</Button>
                  <Button type="default" size="large" onClick={() => navigate("/faqs")}>Learn More</Button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="aboutCompanyInfoSection">
          <div className="container">
            <div className="aboutCompanyInfoContent">
              <h2 className="aboutCompanyInfoTitle">Company Information</h2>
              <div className="aboutCompanyInfoGrid">
                <div className="aboutCompanyInfoItem">
                  <h4>Registered Name</h4>
                  <p>Pingvite Private Limited</p>
                </div>
                <div className="aboutCompanyInfoItem">
                  <h4>Nature of Business</h4>
                  <p>Event discovery, ticketing and registration platform</p>
                </div>
                <div className="aboutCompanyInfoItem">
                  <h4>Registered Address</h4>
                  <p>Tower 6, 401, The Soul, New Town Rajarhat, Kolkata, West Bengal - 700135, India</p>
                </div>
                <div className="aboutCompanyInfoItem">
                  <h4>Email</h4>
                  <p>info@pingvite.in</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* FOOTER */}
      <Footer />
    </>
  );
}